import {createSlice} from "@reduxjs/toolkit";

const courseSlice = createSlice({
    name: "courseReducer",
    initialState: {
        searchParam : "",
        categories : [],
    },
    reducers: {
        setSearchParam(state, action) {
            state.searchParam = action.payload;
        },
        setCategories(state, action) {
            state.categories = action.payload;
        }
    }
});

export const courseAction = courseSlice.actions;

export default courseSlice;